// Format an ISO date to PHT
export function formatISOToPHT(isoDate) {
  if (!isoDate) return '';

  try {
    const date = new Date(isoDate);
    return date.toLocaleDateString('en-PH', {
      timeZone: 'Asia/Manila',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
}

export function isValidISODate(str) {
  if (typeof str !== 'string') return false;

  // ISO 8601 format regex (e.g., 2025-11-21T02:25:35.822Z)
  const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z$/;

  if (!isoRegex.test(str)) return false;

  // Check if creating a Date object results in a valid date
  const date = new Date(str);
  return !isNaN(date.getTime());
}
